import React from "react";
import { useNavigate } from "@reach/router";

import logo from "../assets/logo.svg";
import { useAuth } from "../context/AuthContext";

import { ReactComponent as Logout } from "../assets/icons/logout.svg";

export default function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  return (
    <header className="h-20 flex items-center px-12 bg-active shadow-md">
      <img className="w-24 mr-28" alt="logo" src={logo} />
      <div className="w-56 h-10">
        <div className="text-white text-base font-bold">{user?.name}</div>
        <div className="text-gray-300 text-base font-bold">{user?.role}</div>
      </div>
      <div className="w-56 h-10">
        <div className="text-white text-base font-bold">{user?.email}</div>
      </div>
      <div className="grow" />
      <button
        onClick={async () => {
          await logout();
          navigate("/login");
        }}
        className="text-gray-400 font-bold text-base flex flex-row items-center gap-2"
      >
        <Logout className="fill-gray-400" /> Sair
      </button>
    </header>
  );
}
